import { render } from "./HomeRouter.vue?vue&type=template&id=bbeafb8a"
const script = {}

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__